module.exports = __webpack_public_path__ + "img/violet_006.3ab71f8a.png";